import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import { Page } from '~/components/Page'
import { SignInFooter } from '~/components/SignInFooter'

import { PasswordResetForm } from './PasswordResetForm'
import { PasswordResetSuccess } from './PasswordResetSuccess'
import { TypographyDark } from '~/components/TypographyDark'

export const PasswordResetPage = () => {
  const { token } = useParams<{ token: string }>()
  const { t } = useTranslation()
  const [success, setSuccess] = useState<boolean>()

  return (
    <Page title={t('account.passwordReset.titleText')}>
      {success && <PasswordResetSuccess />}

      {!success && (
        <Stack spacing={2}>
          <TypographyDark variant="h4" gutterBottom align="center">
            {t('account.passwordReset.titleText')}
          </TypographyDark>

          <PasswordResetForm token={token!} setSuccess={setSuccess} />

          <Box mt={2} pb={8}>
            <SignInFooter />
          </Box>
        </Stack>
      )}
    </Page>
  )
}
